import { Cell } from '@table-library/react-table-library/table';
import UserDomains from '../UserDomains';
import { isTrue } from '../../helpers/isTrue';
import UserCancelationBtn from '../UserCancelation/OnlyButton';

export const COLUMNS = (t) => [
    {
        label: t('customers.table.name_username'),
        key: 'first_name',
        data: 'first_name',
        sortType: 'string',
        cellSize: 'minmax(150px, 1.5fr)',
        Component: Cell,
        renderCell: ({ item }) => (
            <strong className="d-flex align-items-center">
                <label htmlFor={item.email}>
                    {item.first_name || item.username} {item.last_name}
                </label>
            </strong>
        ),
    },
    {
        label: t('customers.table.email'),
        key: 'email',
        data: 'email',
        sortType: 'string',
        Component: Cell,
        cellSize: 'minmax(120px, 1fr)',
    },
    {
        label: t('customers.table.domain'),
        key: 'domain',
        data: 'domain',
        Component: Cell,
        cellSize: 'minmax(200px, 2fr)',
        renderCell: ({ item }) => <UserDomains user_id={item.id} domains={item.domains} />,
    },
    {
        label: t('customers.table.date_joined'),
        key: 'date_joined',
        data: 'date_joined',
        Component: Cell,
    },
    {
        label: t('customers.table.last_login'),
        key: 'last_login',
        data: 'last_login',
        Component: Cell,
    },
    {
        label: t('customers.table.user_type'),
        key: 'user_type',
        data: 'user_type',
        sortType: 'string',
        Component: Cell,
        renderCell: ({ data }) => (data === 'User' ? 'Main User' : data),
    },
    {
        label: t('customers.table.licenses'),
        key: 'licenses',
        data: 'licenses',
        Component: Cell,
        renderCell: ({ item }) => {
            const isShowPlan = item.user_license_license_id || item?.plan_display;
            const name = item?.plan_display || item?.user_license_plan_name;
            const interval = item?.plan_interval || item?.user_license_plan_interval;
            return (
                <div>
                    <small className="word-break">
                        {isTrue(item.user_license_license_deactivated) ||
                        item.user_type === 'Viewer' ||
                        !isShowPlan ? (
                            <span style={{ color: '#999' }}>-</span>
                        ) : (
                            <>
                                {name}
                                <br />
                                {interval}
                                {!isTrue(item.user_cancel_at_period_end) && (
                                    <div>
                                        <a
                                            data-bs-toggle="modal"
                                            data-bs-target={`#modal-${item.id}`}
                                            type="button"
                                            className="btn deactivate-btn"
                                        >
                                            Deactivate
                                        </a>
                                    </div>
                                )}
                            </>
                        )}
                    </small>
                    <div
                        className="modal fade"
                        id={`modal-${item.id}`}
                        tabIndex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel">
                                        {t('customers.table.deactivate_confirm')}
                                    </h6>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    ></button>
                                </div>
                                <div className="modal-footer">
                                    <UserCancelationBtn user_id={item.id} fromAdmin />
                                    <button
                                        type="button"
                                        className="btn btn-light"
                                        data-bs-dismiss="modal"
                                    >
                                        {t('customers.table.cancel')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('customers.table.subscription'),
        key: 'subscription_status',
        data: 'subscription_status',
        Component: Cell,
        cellSize: 'minmax(100px, 0.8fr)',
        renderCell: ({ data, item }) => {
            if (data === 'None') return '-';
            return (
                <div>
                    {data}
                    <br />
                    {isTrue(item.cancel_at_period_end) &&
                        `${t('customers.table.till')} ${item.cancel_in}`}
                </div>
            );
        },
    },
    {
        label: t('customers.table.login'),
        key: 'log_in',
        data: 'log_in',
        Component: Cell,
        cellSize: 'minmax(60px, 0.5fr)',
        renderCell: ({ item }) => (
            <a href={`/customers/login_as/${item.id}`}>
                <i className="icofont-login"></i>
            </a>
        ),
    },
];
